import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import SolutionsSection from './components/SolutionsSection';
import ToolsSection from './components/ToolsSection';
import AboutSection from './components/AboutSection';
import CommunitySection from './components/CommunitySection';
import AnnouncementPopup from '@/components/feature/AnnouncementPopup';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <AnnouncementPopup />
      <Navbar />
      <main>
        <HeroSection />
        <SolutionsSection />
        <ToolsSection />
        <CommunitySection />
        <AboutSection />
      </main>
      <Footer />
    </div>
  );
}
